import type { HuntAggressiveness } from '@/types';

export interface HuntScheduleEntry {
  id: string;
  name: string;
  agent: string;
  prompt: string;
  scope: string[];
  aggressiveness: HuntAggressiveness;
  last_run_at: string;
}

export interface HuntScheduleConfig {
  enabled: boolean;
  entries: HuntScheduleEntry[];
}

export const HUNT_SCHEDULE_DEFAULT_CONFIG: HuntScheduleConfig = {
  enabled: false,
  entries: [],
};

export const HUNT_SCHEDULE_SETTING_KEY = 'hunt_schedule';

export const HUNT_AGENT_OPTIONS = [
  { value: 'hannibal', label: 'Default (Hannibal)' },
  { value: 'hannibal-cloud', label: 'Cloud infrastructure' },
  { value: 'hannibal-webapp', label: 'Web application' },
  { value: 'hannibal-llm', label: 'LLM application' },
];

export function newEntry(): HuntScheduleEntry {
  return {
    id: crypto.randomUUID(),
    name: '',
    agent: 'hannibal',
    prompt: '',
    scope: [],
    aggressiveness: 'balanced',
    last_run_at: '',
  };
}
